// @ts-ignore
import { configureClientStore } from './clientStore';
import { configureRenderStore } from './renderStore';

const createStore = () => {
  if (typeof window !== 'undefined') {
    return configureClientStore();
  }
  return configureRenderStore();
};

export const store = createStore();
